import { sheetManager } from "./sheet-manager";

export function useSheet() {
  return {
    close: sheetManager.close,
    closeAll: sheetManager.closeAll,
    open: sheetManager.open,
  } as const;
}
